import { CheckBoxWithLabelWidget, InlineAlertType, InlineAlertWidget } from '@tableau/widgets';
import React, { useState } from 'react';
import ReactMarkdown from 'react-markdown';

import { Messages } from '~src/codegen/Localize';

import * as styles from '../styles/LegalDisclaimerStyle';

const BROADCAST_LEGAL_TEST_ID = 'legal-disclaimer';
export interface LegalDisclaimerProps {
	checkBoxOnChange: (status: boolean) => void;
}

export const BroadcastLegalDisclaimer = (props: LegalDisclaimerProps) => {
	const [checkedBox, setCheckedBox] = useState(false);

	const handleChangeWrapper = () => {
		const checkBoxStatus = !checkedBox;
		setCheckedBox(checkBoxStatus);
		props.checkBoxOnChange(checkBoxStatus);
	};

	return (
		<div style={styles.containerWrapper}>
			<InlineAlertWidget
				style={styles.inlineAlert}
				children={getContent()}
				type={InlineAlertType.Info}
				testId={`${BROADCAST_LEGAL_TEST_ID}-inline-alert`}
			/>
			<div style={styles.checkbox}>
				<CheckBoxWithLabelWidget
					checked={checkedBox}
					handleChange={handleChangeWrapper}
					testId={`${BROADCAST_LEGAL_TEST_ID}-checkbox`}
					label={Messages.broadcastAcceptTermsOfUseCheckBox()}
					disabled={false} />
			</div>

		</div>
	);
};

const getContent = (): JSX.Element => {
	return (
		<>
			<div data-tb-test-id={BROADCAST_LEGAL_TEST_ID + '-warning'} style={styles.warning}>
				{Messages.broadcastJustInTimeLegalDisclaimerWarning()}
			</div>
			<div data-tb-test-id={BROADCAST_LEGAL_TEST_ID + '-prefix'} style={styles.prefix}>
				{Messages.broadcastJustInTimeLegalDisclaimerPrefix()}
			</div>
			<div data-tb-test-id={BROADCAST_LEGAL_TEST_ID + '-body'} style={styles.body}>
				<ReactMarkdown
					source={Messages.broadcastJustInTimeLegalDisclaimerBody()} />
			</div>
		</>
	);
};